import React from "react";
import { LoginForm } from "../../components/forms/auth-form/login-form";
import { siteSettings } from "../../settings/site-settings";
import LoginLottie from "../../components/auth/login-lottie";
import usePageTitle from "../../hooks/usePageTitle";

const Login = () => {
  usePageTitle(`${siteSettings.siteName} | Login`);
  return (
    <div className="min-h-screen h-screen w-full overflow-hidden text-body bg-blackLight flex flex-col">
      <header className=" relative">
        <div className="absolute top-0 left-0 w-full ">
          <LoginLottie />
        </div>
      </header>

      <main className="flex-grow mt-20 flex items-center justify-center">
        <LoginForm />
      </main>

      <footer className="p-4 text-sm absolute bottom-0  w-full">
        <div className="w-full h-full flex justify-center items-center">
          <p>
            &copy; {new Date().getFullYear()} {siteSettings.siteName}. Developed
            by{"  "}
            <a
              href={siteSettings.author.website}
              target="_blank"
              rel="noreferrer"
              className="text-primary font-bold"
            >
              {siteSettings.author.name}
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Login;
